import type { Dependency } from '@wendellhu/redi';
import { IHttpServiceToken } from './interfaces/http.interface';
import { IStorageServiceToken } from './interfaces/storage.interface';
import { ICosService } from './interfaces/cos-service.interface';
import { HttpService } from './services/http.service';
import { StorageService } from './services/storage.service';
import { CosService } from './services/cos/cos.service';

export const BackendCoreModule = {
  providers: [
    [IHttpServiceToken, { useClass: HttpService }],
    [IStorageServiceToken, { useClass: StorageService }],
    [ICosService, { useClass: CosService }],
  ] satisfies Dependency[],
};
